export default __webpack_public_path__ + "static/media/hotspot-outer-white.fe8fde0b.svg";